import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, CAN_CREATE_CLIENT_TYPES, CAN_EDIT_CLIENT_TYPES} from "../../../lib/permissions";

const create = {
    table: 'client_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Client Type',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'client_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Client Type',
        type: 'object',
        required: ['description'],
        properties: {
            client_type_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        client_type_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Client Types',
    description: 'Client types allow you to categorise clients.',
    table: 'client_types',
    fields: ['client_type_id', 'description'],
    uniqueKey: 'client_type_id',
    columns: [
        {Header: 'ID', accessor: 'client_type_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ClientTypes extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(CAN_CREATE_CLIENT_TYPES)}
                canEdit={checkPermission(CAN_EDIT_CLIENT_TYPES)}
            />
        )
    }
}

export default ClientTypes